"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var actionMetadataKey = Symbol('dynamicActions');
var actionParamKey = Symbol('dynamicActionParams');
exports.DYNAMIC_ACTION_CONTAINERS = new core_1.InjectionToken('Container with dynamic action');
var DynamicArgumentType;
(function (DynamicArgumentType) {
    DynamicArgumentType[DynamicArgumentType["Field"] = 0] = "Field";
    DynamicArgumentType[DynamicArgumentType["Context"] = 1] = "Context";
    DynamicArgumentType[DynamicArgumentType["State"] = 2] = "State";
})(DynamicArgumentType = exports.DynamicArgumentType || (exports.DynamicArgumentType = {}));
function getDynamicActions(target) {
    return Reflect.getOwnMetadata(actionMetadataKey, target);
}
exports.getDynamicActions = getDynamicActions;
function getDynamicActionsWithContext(target, ctx) {
    var allActions = Reflect.getOwnMetadata(actionMetadataKey, target);
    if (allActions) {
        allActions.forEach(function (action) {
            var method = (action.descriptor.value);
            action.descriptor.value = function () {
                return method.apply(ctx, arguments);
            };
        });
    }
    return allActions;
}
exports.getDynamicActionsWithContext = getDynamicActionsWithContext;
function DynamicAction(name, fieldNames) {
    return function (target, propertyName, descriptor) {
        var existingActions = Reflect.getMetadata(actionMetadataKey, target) || [];
        existingActions.push({
            title: name,
            actionName: propertyName,
            fields: fieldNames,
            descriptor: descriptor,
            params: Reflect.getMetadata(actionParamKey, target, propertyName) || [],
            async: false
        });
        Reflect.defineMetadata(actionMetadataKey, existingActions, target);
    };
}
exports.DynamicAction = DynamicAction;
function AsyncDynamicAction(name, fieldNames) {
    return function (target, propertyName, descriptor) {
        var existingActions = Reflect.getMetadata(actionMetadataKey, target) || [];
        existingActions.push({
            title: name,
            actionName: propertyName,
            fields: fieldNames,
            descriptor: descriptor,
            params: Reflect.getMetadata(actionParamKey, target, propertyName) || [],
            async: true
        });
        Reflect.defineMetadata(actionMetadataKey, existingActions, target);
    };
}
exports.AsyncDynamicAction = AsyncDynamicAction;
function FieldParam(value) {
    return function (target, propertyKey, parameterIndex) {
        var existingParams = Reflect.getMetadata(actionParamKey, target, propertyKey) || [];
        existingParams.push({
            type: DynamicArgumentType.Field,
            value: value,
            index: parameterIndex
        });
        Reflect.defineMetadata(actionParamKey, existingParams, target, propertyKey);
    };
}
exports.FieldParam = FieldParam;
function ContextParam(value) {
    return function (target, propertyKey, parameterIndex) {
        var existingParams = Reflect.getMetadata(actionParamKey, target, propertyKey) || [];
        existingParams.push({
            type: DynamicArgumentType.Context,
            value: value,
            index: parameterIndex
        });
        Reflect.defineMetadata(actionParamKey, existingParams, target, propertyKey);
    };
}
exports.ContextParam = ContextParam;
function StateParam(value) {
    return function (target, propertyKey, parameterIndex) {
        var existingParams = Reflect.getMetadata(actionParamKey, target, propertyKey) || [];
        existingParams.push({
            type: DynamicArgumentType.State,
            value: value,
            index: parameterIndex
        });
        Reflect.defineMetadata(actionParamKey, existingParams, target, propertyKey);
    };
}
exports.StateParam = StateParam;
//# sourceMappingURL=action-decorators.js.map